<script>
  import { formatDur } from "./utils.js";

  export let tooltip = null;

  function tooltipStyle(x, y) {
    const w = 280;
    const vw = typeof window !== "undefined" ? window.innerWidth : 1200;
    const left = x + 14 + w > vw ? x - w - 10 : x + 14;
    return `left:${left}px;top:${y + 14}px`;
  }
</script>

{#if tooltip}
  <div
    class="fixed z-50 pointer-events-none bg-gray-900 text-white text-xs rounded-lg px-3 py-2.5 shadow-xl max-w-[280px]"
    style={tooltipStyle(tooltip.x, tooltip.y)}
  >
    <div class="font-semibold text-white leading-snug mb-1">{tooltip.span.name}</div>
    <div class="text-gray-300 tabular-nums font-medium">
      {formatDur(tooltip.span.end_time_ns - tooltip.span.start_time_ns)}
    </div>
    {#if tooltip.span.kind}
      <div class="text-content-subtle mt-0.5">{tooltip.span.kind}</div>
    {/if}
    {#each Object.entries(tooltip.span.attributes || {}).slice(0, 6) as [k, v]}
      <div class="mt-1 flex gap-1.5 min-w-0">
        <span class="text-content-subtle shrink-0">{k}:</span>
        <span class="text-gray-300 truncate">{v}</span>
      </div>
    {/each}
  </div>
{/if}
